import React, { useEffect, useState } from "react";
import Head from "@components/Head";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useModal } from "@components/ModalContext";
import ItripIdh from "./ItripIdh";
import OurStrength from "./OurStrength";
import Skoop from "./Skoop";
import Booking from "./Booking";
import Chart from "./Chart";
import Stat from "./Stat";
import { apiSend, getRoute } from "@services/axios";
import { useParams } from "react-router-dom";

import { useDispatch } from "react-redux";
import { setSectionName } from "@services/redux/slices/globalSlice";
const HotelDetail = (props) => {
  const { openModal, setSize, setTitle, closeModal } = useModal();
  const dispatch = useDispatch();
    const { t } = useTranslation();
    const productId = useParams().id;
    const [imageList, setImageList] = useState([]);
  
    const loadAlbum = async () => {
      const response = await apiSend(
        [getRoute("PRODUCT_RETRIEVE"), "album", productId].join("/"),
        "get"
      );
      setImageList(response?.data?.result);
    };
  
    useEffect(() => {
      const timerId = setTimeout(async () => {
        await loadAlbum();
      }, 500);
      dispatch(setSectionName("product_details"));
      return () => {
        clearTimeout(timerId);
      };
    }, []);
console.log("images",imageList[0]?.image_url)
  const tripAdvisoir = () => {
    setSize("lg");
    setTitle("tripAdvisoir");
    openModal(<ItripIdh mode={props.mode} t={t} closeModal={closeModal} />);
  };
  const ourStrength = () => {
    setSize("lg");
    setTitle("our_strength");
    openModal(<OurStrength mode={props.mode} t={t} closeModal={closeModal} />);
  };
console.log('props',props.product.isActive)

  return (
    <>

      

      

      <div className="px-3 my-4">
        <Row className="d-flex justify-content-center w-full">
    <Col lg="4" xl="4">
          <Head
        data={props.product.name}
        dynamicData={t("status")}
        dynamicData1={props.product.status}
        dd={props.product.isActive  }
        dd1={props.profile.data.phone}
        country={props.product.country.name}
        city={props.product.city.name}
        images={imageList}
        confirmation={props.product.booking_confirmation_mode}
      />
          </Col>
          <Col lg="8" xl="8" className="mb-3 p-4 rounded bg-white">
            <div style={{ height: "100%" }}>
              <span className="fs-4 fw-bold text-dark mx-2">
                {t("ho_act_skoop")}
              </span>
              {/* <p className="fs-8 pb-4 mx-2">{t("ho_act_skoop_txt")}</p> */}
              <Skoop t={t} />
            </div>
          </Col>
        
        </Row>
      </div>
    
      <div className="px-3 my-4">
        <Row>
          <Col xl="9" className="my-2 px-0">
            <Chart t={t} product_id={props.product.id} />
          </Col>
          <Col xl="3">
            <Stat t={t} product_id={props.product.id} />
          </Col>
        </Row>
      </div>
      <div className="px-3 my-4" id="othersBooking">
        <Row>
          <Col xl="12" className="my-2 px-0">
            <div className="bg-white  p-4 rounded">
              <Booking
                t={t}
                product_id={props.product.id}
                service={props.product.service}
                country={props.product.country.id}
                {...props}
              />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default HotelDetail;
